import {Injectable} from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from "@angular/router";
import {Observable} from "rxjs";
import {UserInfoService} from "../user-info.service";

@Injectable()
export class AdminAuthGuard  {
  constructor(private userInfo: UserInfoService, private router: Router) {
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    if (this.userInfo.loggedIn && this.userInfo.isAdmin) {
      return true;
    } else {
      this.router.navigate(['']);
      return false;
    }
  }
}
